module.exports = __webpack_public_path__ + "static/img/43.9cfca267.png";